module.exports = __webpack_public_path__ + "static/media/aggregated-measure-icon.40c04f45.svg";